import {
  appLogout,
  createAsyncThunk,
  createSlice,
  injectSlice,
} from '@betty/toolkit/state';
import { DailyGiftState } from './dailyGift.types';
import { RewardsService } from '@betty/toolkit/services';
import DailyGiftService from '../services/DailyGiftService/DailyGiftService';

const initialState: DailyGiftState = {
  data: null,
  dataState: 'idle',
  claimDataState: 'idle',
};

export const fetchDailyGift = createAsyncThunk('dailyGift/fetch', async () => {
  const response = await DailyGiftService.getDailyGift();
  return response;
});

export const claimDailyGift = createAsyncThunk(
  'dailyGift/claim',
  async (rewardId: number) => {
    const response = await RewardsService.claimReward({
      pathParams: { id: rewardId },
    });
    return response;
  },
);

const dailyGift = createSlice({
  name: 'dailyGift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDailyGift.pending, (state) => {
      state.dataState =
        state.dataState === 'fulfilled' ? 'refreshing' : 'pending';
    });

    builder.addCase(fetchDailyGift.fulfilled, (state, action) => {
      state.data = action.payload;
      state.dataState = 'fulfilled';
    });

    builder.addCase(fetchDailyGift.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(claimDailyGift.pending, (state) => {
      state.claimDataState = 'pending';
    });

    builder.addCase(claimDailyGift.fulfilled, (state) => {
      state.claimDataState = 'fulfilled';
    });

    builder.addCase(claimDailyGift.rejected, (state) => {
      state.claimDataState = 'rejected';
    });

    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const withDailyGift = injectSlice({
  reducerPath: 'dailyGift',
  reducer: dailyGift.reducer,
});

export const selectDailyGift = withDailyGift.selector(
  (state) => state.dailyGift?.data,
);
export const selectDailyGiftStatus = withDailyGift.selector(
  (state) => state.dailyGift?.data?.status,
);

export const selectDailyGiftDataState = withDailyGift.selector(
  (state) => state.dailyGift?.dataState,
);

export const selectClaimDailyGiftDataState = withDailyGift.selector(
  (state) => state.dailyGift?.claimDataState,
);

declare global {
  interface LazyLoadedSlices {
    dailyGift: ReturnType<typeof dailyGift.reducer>;
  }
}
